import { render, staticRenderFns } from "./PtJobOfferDetailPage.vue?vue&type=template&id=51e0556a"
import script from "./PtJobOfferDetailPage.vue?vue&type=script&lang=ts"
export * from "./PtJobOfferDetailPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports